var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNousersvg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 208,
    viewBox: "0 0 208 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7682_5106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208 104C208 134.437 194.922 161.821 174.083 180.841C155.594 197.711 130.999 208 104 208C77.0006 208 52.4062 197.711 33.917 180.841C13.0776 161.821 0 134.437 0 104C0 46.5648 46.5648 0 104 0C161.435 0 208 46.5648 208 104Z",
    fill: "#D6E5E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208 104C208 134.437 194.922 161.821 174.083 180.841C155.594 197.711 130.999 208 104 208V0C161.435 0 208 46.5648 208 104Z",
    fill: "#BACFC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.083 180.428V180.842C155.594 197.71 130.999 208 104 208C77.0006 208 52.4062 197.711 33.917 180.842V180.427C33.917 150.3 53.0282 124.548 79.768 114.669C87.3202 111.873 95.4846 110.347 104 110.347C112.515 110.347 120.68 111.873 128.237 114.669C154.976 124.552 174.083 150.3 174.083 180.428Z",
    fill: "#205440"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.083 180.428V180.842C155.594 197.71 130.999 208 104 208V110.346C112.515 110.346 120.68 111.873 128.237 114.669C154.976 124.552 174.083 150.3 174.083 180.428Z",
    fill: "#023C26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.984 79.1871C146.984 102.888 127.705 122.173 104 122.173C80.2989 122.173 61.0146 102.888 61.0146 79.1871C61.0146 55.4864 80.2993 36.2021 104 36.2021C127.705 36.2021 146.984 55.4864 146.984 79.1871Z",
    fill: "#6FC0A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.985 79.1871C146.985 102.888 127.706 122.173 104 122.173V36.2026C127.706 36.2026 146.985 55.4865 146.985 79.1871Z",
    fill: "#28936A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7682_5106"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 208,
    height: 208,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNousersvg);
export default __webpack_public_path__ + "static/media/nousersvg.d0b678f0bc2e6e998a8e79ccbc9c3df5.svg";
export { ForwardRef as ReactComponent };